/**
 * Favourite Type enum
 */
export enum FavouriteType {
  UNSPECIFIED = 0,
  IS_FAVOURITE = 1,
  IS_FAVOURITE_MUTED = 2,
}
